enum UserType {
    carrierOperator,
    carrierAdmin,
}

export default UserType;
